import * as React from "react";
import useSWR from "swr";
import { resolveStartingShop } from "../domain/startingShop";
import { clearTabRoute, readTabRoute } from "../services/tabShop";
import fetcher from "./fetcher";

const NO_START = { route: null, newestRoute: null };
const OPTIONS = { shouldRetryOnError: false };

const shopKey = (route) =>
  `/api/influencer?dashboard=true&route=${encodeURIComponent(route)}`;

export default function useStartingShop({ enabled = true } = {}) {
  const [tabRoute] = React.useState(readTabRoute);
  const [rejected, setRejected] = React.useState(() => new Set());

  const needsStart =
    resolveStartingShop({ tabRoute, rejected }).source === "needsStart";
  const startResponse = useSWR(
    enabled && needsStart ? "/api/dashboard/shops/start" : null,
    fetcher,
    OPTIONS,
  );
  const start =
    startResponse.data ?? (startResponse.error ? NO_START : undefined);
  const resolution = resolveStartingShop({ tabRoute, start, rejected });

  const { route } = resolution;
  const shopResponse = useSWR(
    enabled && route ? shopKey(route) : null,
    fetcher,
    OPTIONS,
  );

  React.useEffect(() => {
    if (!shopResponse.error || !route) return;
    if (route === tabRoute) clearTabRoute();
    setRejected((current) => new Set(current).add(route));
  }, [shopResponse.error, route, tabRoute]);

  return {
    // SWR serves a key's cached data while revalidating and beside a later error, so only a
    // fresh, successful answer counts: a renamed shop's old copy would otherwise loop.
    shop:
      shopResponse.isValidating || shopResponse.error
        ? null
        : shopResponse.data ?? null,
    hasNoShop: resolution.source === "none",
  };
}
